/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import Drawer from '../drawer/Drawer';
import ReportOverview from '../report/ReportOverview';
import { ReportDrawerViewModel } from 'src/types/view-models/report-drawer.view.model';
import Disclosures from 'src/bw/bw-drawer/disclosures/Disclosures';
import { TimePeriod } from 'src/types/time-period';
import MonteCarlo from '../report/MonteCarlo';
import Selectors from 'src/utils/selectors';

export default class ReportDrawer extends Component<ReportDrawerViewModel> {
    public override render(): ReactComponentElement<any> {
        const notPast: boolean = this.props.drawerProps.period !== TimePeriod.PAST;
        return (
            <Drawer
                drawerProps={this.props.drawerProps}
                title={this.props.title}
                withBackButton
                disclosures={<Disclosures withInvesting />}
                data-cy={Selectors.PlanAhead.REPORT_DRAWER}
            >
                <ReportOverview
                    drawerProps={this.props.drawerProps}
                    reportType={this.props.reportType}
                    monteCarlo={this.props.monteCarlo}
                ></ReportOverview>
                {notPast && this.props.monteCarlo && this.props.handleClick ? (
                    <MonteCarlo monteCarlo={this.props.monteCarlo} handleClick={this.props.handleClick} />
                ) : null}
                {this.props.children}
            </Drawer>
        );
    }
}
